import React, { memo } from 'react'

import {
  bool, func, number, oneOfType, shape, string,
} from 'prop-types'

import { imageShape } from 'Pods/ThreeDStudio/Shared/ImageModal/imageShape'
import References from 'Pods/ThreeDStudio/Shared/References/References'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'
import useBreakpoint from 'Utils/useBreakpoint'

import Actions from './Components/Actions/Actions'
import Arrow from './Components/Arrow/Arrow'

// From 960 the references are a column in the stage's left gutter; below that they leave
// the image for a row under the actions.
const REFERENCES_ROW_BREAKPOINTS = ['xs', 'sm']

function Preview({
  image,
  referencesRunId = null,
  hasPrevious = false,
  hasNext = false,
  onPrevious = NOOP,
  onNext = NOOP,
  isRegenerating = false,
  onRegenerate = null,
  onEdit = NOOP,
  onDownload = NOOP,
  onGenerate3d = NOOP,
}) {
  const isReferencesRow = REFERENCES_ROW_BREAKPOINTS.includes(useBreakpoint())
  // Keyed on the image so stepping to the next one starts collapsed.
  const references = (
    <References
      key={image.id}
      runId={referencesRunId}
      customClass="image-gallery-modal__references"
      stripBreakpoints={EMPTY_ARRAY}
      rowBreakpoints={REFERENCES_ROW_BREAKPOINTS}
    />
  )

  return (
    <div className="image-gallery-modal__preview">
      {/* Hidden below 960, where the modal's header band carries the name instead. */}
      <p className="image-gallery-modal__title cgt-body-md-semibold">{image.title}</p>
      <div className="image-gallery-modal__stage">
        <Arrow direction="previous" isDisabled={!hasPrevious} onClick={onPrevious} />
        <img
          className="image-gallery-modal__image"
          src={image.src}
          alt={image.title}
          style={{ '--ratio': image.aspectRatio }}
        />
        <Arrow direction="next" isDisabled={!hasNext} onClick={onNext} />
        {!isReferencesRow && references}
      </div>
      <Actions
        title={image.title}
        slug={image.slug}
        likeCount={image.likeCount}
        isRegenerating={isRegenerating}
        onRegenerate={onRegenerate}
        onEdit={onEdit}
        onDownload={onDownload}
        onGenerate3d={onGenerate3d}
      />
      {isReferencesRow && references}
    </div>
  )
}

Preview.propTypes = {
  image: shape(imageShape).isRequired,
  referencesRunId: oneOfType([string, number]),
  hasPrevious: bool,
  hasNext: bool,
  onPrevious: func,
  onNext: func,
  isRegenerating: bool,
  onRegenerate: func,
  onEdit: func,
  onDownload: func,
  onGenerate3d: func,
}

export default memo(Preview)
